import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { ProviderTypes } from './constants';
import { CuiProviderDeletion } from './delete-provider';
import { useApiCodeFromAccountId } from './hooks/use-api-code-from-account-id';

export const DeleteFulfillmentProvider = ({ sellerFulfillmentProviderId, onError = noop, onCancel = noop, onRemoveAccount = noop }) => {
  const providerApiCode = useApiCodeFromAccountId(sellerFulfillmentProviderId, ProviderTypes.fulfillment);

  if (!providerApiCode) {
    return null;
  }

  return (
    <CuiProviderDeletion
      accountId={sellerFulfillmentProviderId}
      onCancel={onCancel}
      onError={onError}
      onRemoveAccount={onRemoveAccount}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.fulfillment}
    />
  );
};

DeleteFulfillmentProvider.propTypes = {
  sellerFulfillmentProviderId: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onRemoveAccount: PropTypes.func,
  onCancel: PropTypes.func,
};
